(function () {
  function initCard(card) {
    var checkbox = card.querySelector('[data-terms-checkbox]');
    var button = card.querySelector('.subscription-option__btn--add');
    if (!checkbox || !button) return;
    if (button.getAttribute('data-sold-out') === 'true') return;

    button.disabled = !checkbox.checked;
    checkbox.addEventListener('change', function () {
      button.disabled = !checkbox.checked;
    });
  }

  function initStickyCta() {
    var sticky = document.querySelector('[data-sticky-cta]');
    if (!sticky) return;

    var target =
      document.querySelector('.subscription-options__option--featured') ||
      document.querySelector('.subscription-options__option');
    if (!target) {
      sticky.parentNode.removeChild(sticky);
      return;
    }

    var trigger = sticky.querySelector('[data-sticky-cta-btn]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(target);
  }

  function init() {
    var cards = document.querySelectorAll('.subscription-options__option');
    for (var i = 0; i < cards.length; i++) {
      initCard(cards[i]);
    }
    initStickyCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
